import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BellRing } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../../components/ui/Tabs';
import { PageLayout } from '../../../components/ui/PageLayout';
import AppIcon from '../../../components/AppIcon';
import CompanyDefaultsTab from './components/CompanyDefaultsTab';
import UserManagementTab from './components/UserManagementTab';
import EngagementJobsTab from './components/EngagementJobsTab';

const AdminNotificationManagement: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('company-defaults');

  return (
    <PageLayout
      title={t('Notification Management')}
      description={t('Configure company-wide notification defaults and manage user preferences')}
      icon={BellRing}
      accentColor="slate"
    >
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full grid-cols-3 mb-4">
          <TabsTrigger value="company-defaults">
            <AppIcon name="Building2" size={16} className="ltr:mr-2 rtl:ml-2" />
            {t('Company Defaults')}
          </TabsTrigger>
          <TabsTrigger value="engagement-jobs">
            <AppIcon name="Sparkles" size={16} className="me-2" />
            {t('Engagement Jobs')}
          </TabsTrigger>
          <TabsTrigger value="user-management">
            <AppIcon name="Users" size={16} className="ltr:mr-2 rtl:ml-2" />
            {t('User Management')}
          </TabsTrigger>
        </TabsList>
        <TabsContent value="company-defaults">
          <CompanyDefaultsTab />
        </TabsContent>
        {/* CO-240 — per-company enablement for the Engagement & Performance jobs. Deliberately a tab
            on this page rather than a new route: it inherits the nav entry, the route guard, and both
            module/page gating layers with no changes to any of them. */}
        <TabsContent value="engagement-jobs">
          <EngagementJobsTab />
        </TabsContent>
        <TabsContent value="user-management">
          <UserManagementTab />
        </TabsContent>
      </Tabs>
    </PageLayout>
  );
};

export default AdminNotificationManagement;
